import Vue from "vue";
import Vuex from "vuex";

import db from "../components/firebaseInit";
import router from "@/router";
import firebase from "firebase";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //Login details has been set from Login component
    //user_display_name: null,    //IT is set in profile_data object below
    curr_user_email: null,
    is_logged_in: firebase.auth().currentUser,

    linko_id: "", //Value has been set form Navbar component->mounted()
    loggedin_user_uid: "", //     -------''------------

    links: [],
    profile_data: "",

    profile_loaded: false,
    links_loaded: false,

    error_msg_pl: "",
    error_msg_ll: ""
  },
  getters: {
    getLinks: state => {
      return state.links;
    }
  },
  mutations: {
    loadProfileInfo: state => {
      console.log("in mutations->loadProfileInfo");
      //state.linko_id = "akajay2001";

      console.log("LinkoId :", state.linko_id);
      //load profile details of current user
      db.collection("USER_PROFILE")
        .where("linko_id", "==", state.linko_id)
        .get()
        .then(
          querySnapshot => {
            querySnapshot.forEach(doc => {
              const data = {
                //replace the value with "" if null to avoid error in filter fun
                user_display_name: doc.data().user_display_name || "",
                user_bio: doc.data().user_bio || "",
                user_profile_pic: doc.data().user_profile_pic || "",
                user_activity_pics: doc.data().user_activity_pics || "",
                user_social_links: doc.data().user_social_links || "",
                uid: doc.data().uid || ""
              };
              state.profile_data = data;
            });

            if (state.profile_data != "") {
              state.error_msg_pl = "Profile fetched ";
              state.profile_loaded = true;
            } else {
              state.error_msg_pl =
                "No matching Profile Found for LinkO Id : " + state.linko_id;
            }

            console.log("profile_loaded : " + state.profile_loaded);
          },
          (onerror = err => {
            state.error_msg_pl = "Error in loading Profile !" + err;
            console.log(err); // Error: "It broke"
          })
        );
    },

    //function to load links details
    loadLinksInfo: state => {
      console.log("in mutations->loadLinksInfo");

      let rec_arr = []; //array of records fetched from firestore
      let links_count = 0; //count total no of records
      //state.profile_data.uid="MXCDUOjiVMcvuUoi5X9Aj6ei4hI3";
      console.log("Linko Id : " + state.linko_id);
      console.log("Logedin state : " + state.is_logged_in);
      console.log("state.profile_data.uid : " + state.profile_data.uid);
      console.log("state.loggedin_user_uid : " + state.loggedin_user_uid);

      var q = db.collection("linkinfo");

      //COND1 : viewer/user is on mylinko home page, NOT on any user's page.
      // So, display all the public links belongs to all user or based on one's interest or trending links
      if (state.linko_id == "") {
        //show only public links from all users
        q = q.where("link_type", "==", "Public");
      }
      //COND1 : viewer is on user's homepage - show only links that belongs to that linkoId
      else if (state.linko_id != "") {
        q = q.where("linko_id", "==", state.linko_id);

        //COND : Currently loggedin user is NOT same as user on whose homepage is being visited
        if (state.profile_data.uid != state.loggedin_user_uid)
          q = q.where("link_type", "==", "Public"); //show only public links
        //else  //loggedin user is on his own homepage. So, display all type(Private, Public, Friend, Family) of links that belogns to him.
      }
      //My linko homepage BUT loggedin
      else {
        //display error message : invalid condition
        console.log("Invalid Condition meet ! ");
      }
      q.orderBy("link_id")
        .get()
        .then(
          querySnapshot => {
            querySnapshot.forEach(doc => {
              const data = {
                //replace the value with "" if null to avoid error in filter fun
                link_id: doc.data().link_id || "",
                link_no: doc.data().link_no || "",
                link_name: doc.data().link_name || "",
                link_url: doc.data().link_url || "",
                link_desc: doc.data().link_desc || "",
                link_type: doc.data().link_type || "",
                link_category: doc.data().link_category || ""
              };
              rec_arr.push(data);
              links_count++;
            });
            state.links = rec_arr;
            //console.log(rec_arr);
            //if (links_count == 0)
            //  state.error_msg_ll = "No Saved Links Found !";

            state.links_loaded = true;
            console.log("links_loaded :" + state.links_loaded);
          },
          (onerror = err => {
            state.error_msg_ll =
              "<br>Error in loading saved Links ! <br>Desc :" + err;
            console.log("Error :", err); // Error: "It broke"
          })
        );
    }
  },
  actions: {
    loadProfileInfo: context => {
      console.log("in action->loadProfileInfo");
      context.commit("loadProfileInfo");
    },
    loadLinksInfo: context => {
      setTimeout(() => {    //TODO :instead of setTimeout(), use some smarter way to ensure that profile info is loaded before calling this function
      console.log("in action->loadLinksInfo");
      context.commit("loadLinksInfo");
       }, 5000);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js